"use client";

import { useEffect, useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function FloatingCallCta() {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-4 left-0 right-0 z-[60] px-4 transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0 pointer-events-none"
      }`}
    >
      <a
        href="tel:+17863774452"
        className="flex items-center justify-center gap-2 w-full bg-[#047857] text-white px-6 py-3.5 text-sm font-bold rounded-full shadow-lg hover:bg-[#065f46] transition-colors whitespace-nowrap"
      >
        <i className="ri-phone-fill text-lg animate-pulse" />
        {t("floatCta.callNow")}
      </a>
    </div>
  );
}